/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 * align {string} column alignment left/center/right
 */

export default [
  {
    id: 'thumbnail',
    label: '',
    field_name: 'thumbnail',
    source_field: 'thumbnail',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 'copy_id',
    label: 'URL/ID',
    field_name: 'copyId',
    source_field: 'id',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
    align: 'center',
  },
  {
    id: 'share',
    label: '',
    field_name: 'share',
    source_field: 'share',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
    align: 'center',
  },
  {
    id: 'date_published',
    label: 'Published',
    field_name: 'datePublished',
    source_field: 'date_published',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
  },
  {
    id: 'title',
    label: 'Title',
    field_name: 'title',
    source_field: 'title',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 'description',
    label: 'Description',
    field_name: 'description',
    source_field: 'intro',
    showColumn: true,
    pinned: false,
    suppressSorting: true,
  },
  {
    id: 'media_type',
    label: 'Media Type',
    field_name: 'mediaType',
    source_field: 'media_type',
    showColumn: true,
    pinned: false,
    align: 'center',
  },
  {
    id: 'level',
    label: 'Level',
    field_name: 'level',
    source_field: 'level_name',
    showColumn: true,
    pinned: false,
  },
  {
    id: 'copyright',
    label: 'Copyright',
    field_name: 'copyright',
    source_field: 'copyright',
    showColumn: true,
    pinned: false,
  },
];
